<template>
  <div class="mine-box">
    <div v-for="item in lists"
      :key="item.cpCode"
      @click="_onLinkDetail(item)"
      class="list-box">
      <div class="item">
        <div class="content">
          <div class="result-box">
            <div class="result-title">测评结果:</div>
            <div class="result-text-box">
              <div class="result-text">{{ item.resultHtml | stripHtml }}</div>
            </div>
          </div>
          <div class="time">{{ item.assessTime }}</div>
        </div>
        <img class="ic-arrow"
          src="../../assets/ic_arrow_right.png">
      </div>
    </div>
    <span v-if="prepared"
      class="page-no-data">
      没有测评数据
    </span>
  </div>
</template>

<script>
import VuxGroup from 'vux/src/components/group'
import VuxCell from 'vux/src/components/cell'
import { injectMixins } from '@/services'
import { getTextContentFromHtml } from '@/helpers'

export default {
  name: 'PageSurveyMine',

  mixins: [
    injectMixins
  ],

  data () {
    return {
      prepared: false,
      lists: []
    }
  },

  async created () {
    await this._ensureBaseInfo()

    try {
      this.pageLoading = true
      const data = await this.gActions.getMineSurveyList(this.code)
      this.lists = data || []
    } finally {
      this.pageLoading = false
    }
    if (!this.lists.length) {
      this.prepared = true
    }
  },

  mounted () {
    this.$watch('baseInfo', (baseInfo) => {
      if (!baseInfo) return
      document.title = (baseInfo.name || '壹零医')
    }, {
      immediate: true
    })
  },

  methods: {
    _onLinkDetail (it) {
      if (it.propose) {
        it.propose = getTextContentFromHtml(it.proposeHtml)
      }

      this.gState.tmpChatResult = it
      this.$router.push(`/survey/detail?key=${it.assessNO}&code=${this.code}`)
    }
  },

  components: {
    VuxGroup,
    VuxCell
  }
}
</script>

<style lang="scss" scoped>
.mine-box {
  background: #f7f8f9;
  padding: 17px 15px;
  // 列表box
  .list-box {
    background-color: #fff;
    border-left: 1px solid #3dd3cb;
    padding: 14px 5px 14px 12px;
    &:active {
      opacity: 0.5;
    }
    // 列表item
    .item {
      display: flex;
      align-items: center;
      // 子项内容
      .content {
        flex: 1;
        // 测评结果
        .result-box {
          display: flex;
          align-items: center;
          font-size: 15px;
          padding-bottom: 3px;
          .result-title {
            white-space: nowrap;
          }
          // 评测内容box(为了解决flex布局无法显示省略号)
          .result-text-box {
            flex: 1;
            width: 0;
            .result-text {
              color: #3dd3cb;
              overflow: hidden;
              padding-left: 5px;
              text-overflow: ellipsis;
              word-break: break-all;
              white-space: nowrap;
            }
          }
        }
        // 测评日期
        .time {
          color: #aaaaaa;
          font-size: 13px;
          padding-top: 3px;
        }
      }
      // 右箭头
      .ic-arrow {
        height: 15px;
        width: 15px;
      }
    }
  }
  .list-box + .list-box {
    margin-top: 13px;
  }
}
</style>
